// extracted by mini-css-extract-plugin
export var chip = "_i2-0";
export var filterDropdown = "_i2-5";
export var filterItem = "_i2-6";
export var icon = "_i2-1";
export var removeButton = "_i2-3";
export var removeIcon = "_i2-4";
export var separator = "_i2-2";